"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResourceContext = void 0;
const tslib_1 = require("tslib");
const api_1 = tslib_1.__importDefault(require("@opentelemetry/api"));
const semantic_conventions_1 = require("@opentelemetry/semantic-conventions");
const resources_1 = require("@opentelemetry/resources");
const defaultResourceServiceName = resources_1.Resource.default().attributes[semantic_conventions_1.SemanticResourceAttributes.SERVICE_NAME];
/**
 * Returns opentelemetry tracing context if available
 * otherwise returns empty object
 *
 * @package
 * @returns Partial<TracingContext>
 */
const getResourceContext = () => {
    var _a, _b;
    const context = {};
    const traceProvider = (_a = api_1.default.trace.getTracerProvider()) === null || _a === void 0 ? void 0 : _a.getDelegate();
    const { [semantic_conventions_1.SemanticResourceAttributes.SERVICE_NAME]: serviceName, [semantic_conventions_1.SemanticResourceAttributes.SERVICE_VERSION]: serviceVersion, } = Object.assign({}, (_b = traceProvider === null || traceProvider === void 0 ? void 0 : traceProvider.resource) === null || _b === void 0 ? void 0 : _b.attributes);
    if (serviceName && serviceName !== defaultResourceServiceName) {
        return {
            serviceName: serviceName,
            serviceVersion: serviceVersion,
        };
    }
    return context;
};
exports.getResourceContext = getResourceContext;
//# sourceMappingURL=resource.js.map